import { itemListaRegularizacaoStyles } from './ItemListaRegularizacao.style'

export function itemListaRegularizacaoIO() {
  return {
    styles: itemListaRegularizacaoStyles
  }
}

export type ItemListaRegularizacaoIO = ReturnType<typeof itemListaRegularizacaoIO>
